import React from 'react';
import ListDropdown from '@alltrails/shared/components/ListDropdown';
import { string } from 'prop-types';
import { userConnectionPropTypes } from '../../../sharedPropTypes';
import Button from '../../../../../components/shared/Button';
import { useRetractRequest } from '../../../hooks/useConnectAction';
import { StringConstantsMixin } from '../../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const { REQUESTED } = StringConstantsMixin.strings.COMMUNITY.BELAY_CONNECTIONS;

const RequestedButton = ({ className, userConnection }) => {
  const retractAction = useRetractRequest(userConnection);

  const links = () => {
    const { href, title } = userConnection.actions.retractRequest;
    return [{ href, label: title }];
  };

  return (
    <ListDropdown
      anchorElement={
        <Button classes={className} variant="small">
          {REQUESTED}
        </Button>
      }
      handleLinkClick={retractAction}
      links={links()}
      alignment="bottom-right"
      verticalOffset={16}
    />
  );
};

RequestedButton.propTypes = {
  className: string,
  userConnection: userConnectionPropTypes.isRequired
};

RequestedButton.defaultProps = {
  className: ''
};

export default RequestedButton;
